// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2a477fc9","780":"f97767cc","964":"2e330c95"}[chunkId] + ".chunk.js";
};